var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3 row col-12 py-3 px-3" },
    [
      _vm.parentKey &&
      !_vm.dataSet?.key_formatted &&
      _vm.parentKey !== "editable"
        ? _c("div", { staticClass: "mb-3 border-bottom col-12 row py-2" }, [
            _c("strong", [_vm._v(_vm._s(_vm.parentKey))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.dataSet, function (value, key) {
        return [
          typeof value === "object" && _vm.isNotPresent(value?.key_formatted)
            ? [
                _c(
                  "div",
                  { staticClass: "col-12 px-4" },
                  [
                    _c("ViewArrayElement", {
                      attrs: { "data-set": value, "parent-key": key },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "border-bottom col-12 px-2" },
                  [
                    _c("ViewJsonSingleElement", {
                      attrs: {
                        "data-set": value,
                        "parent-key": key,
                        col9: true,
                      },
                    }),
                  ],
                  1
                ),
              ],
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }